baseApp.service('DateTimeService', function(){
    return {
        DEFAULT_TIME_FRAME_TYPE : "Week",
        DEFAULT_TIME_FRAME_SIZE : 1,
        calculateUsageType: function(timeFrameType, timeFrameSize){
            if (!timeFrameType){
                timeFrameType = this.DEFAULT_TIME_FRAME_TYPE;
            }
            if (!timeFrameSize){
                timeFrameSize = this.DEFAULT_TIME_FRAME_SIZE;
            }
            switch(timeFrameType){
                case "Day":
                    return "DAY";                   
                case "Week":
                    return "WEEK";
                case "Month":
                    if(timeFrameSize == 1){
                        return "MONTH";
                    }
                    if(timeFrameSize == 3){
                        return "QUARTER";
                    }
            }
            return null;
        },
        calculateTimeFrame: function(timeFrameType, timeFrameSize, fromDate, toDate){
            if (!timeFrameType){
                timeFrameType = this.DEFAULT_TIME_FRAME_TYPE;
            }
            if (!timeFrameSize){
                timeFrameSize = this.DEFAULT_TIME_FRAME_SIZE;
            }
            var now = new Date();
            switch(timeFrameType){
                case "Hour":
                    now.setUTCHours(now.getHours(),0,0,0);
                    toDate = now.getTime()-1;
                    now.setUTCHours(now.getHours()-timeFrameSize,0,0,0);
                    fromDate = now.getTime();
                    break;
                case "Day":
                    now.setUTCDate(now.getDate()-1);
                    now.setUTCHours(23,59,59,999);
                    toDate =  now.getTime();
                    now.setUTCDate(now.getDate()-timeFrameSize);
                    now.setUTCHours(0,0,0,0);
                    fromDate = now.getTime();
                    break;
                case "Week":
                    var day = now.getDay();
                    now.setUTCDate(now.getDate() + (day == 0?-6:1)-day);
                    now.setUTCHours(0,0,0,0);
                    toDate =  now.getTime()-1;
                    now.setUTCDate(now.getDate()-7);
                    fromDate = now.getTime();
                    break;
                case "Month":
                    now.setUTCDate(0);
                    now.setUTCHours(23,59,59,999);
                    toDate = now.getTime();
                    for (let i = 1; i < timeFrameSize; i++) {
                        now.setUTCDate(0);
                    }
                    now.setUTCDate(1);
                    now.setUTCHours(0,0,0,0);
                    fromDate = now.getTime();
                    break;
                case "Custom":
                break;
            }
            return {toDate: toDate, fromDate: fromDate};
        },
        getDateInUTC: function(dateObj) {
            return new Date(Date.UTC(dateObj.getYear() + 1900, dateObj.getMonth(), dateObj.getDate(), dateObj.getHours(), dateObj.getMinutes(), dateObj.getSeconds()));
        }
    };
});
